module.exports = {
  Rechnung: { api: 'Rechnung', human: 'Rechnung' },
  SEPA: { api: 'SEPA', human: 'SEPA-Lastschrift' }
}
